/* eslint-disable angular/controller-name, angular/controller-as */

angular.
module("dx.webapp.results").
controller("dxResultsController", function resultController(
	$scope,
	$rootScope,
	$routeParams,

	DX_QUESTION_TYPE,
	DX_SPELLCHECKSETTING,
	dxExam,
	dxSession,
	DX_EXAM_PARTS,
	RoleTypeEnum,
	DX_WORD_GAP_MODE,

	DX_CAP_SETTINGS,
	DX_GRADING_TYPES,
	dxDialog,
	dxLocalize
) {
	"use strict";


	var examId = parseInt($routeParams.examId, 10);
	var studentId = parseInt($routeParams.studentId, 10);

	$scope.DX_QUESTION_TYPE = DX_QUESTION_TYPE;
	$scope.DX_GRADING_TYPES = DX_GRADING_TYPES;
	$scope.DX_EXAM_PARTS = DX_EXAM_PARTS;
	$scope.DX_CAP_SETTINGS = DX_CAP_SETTINGS;
	$scope.DX_SPELLCHECKSETTING = DX_SPELLCHECKSETTING;
	$scope.DX_WORD_GAP_MODE = DX_WORD_GAP_MODE.STATIC;

	$scope.state = {
		isInitialized: false,
		showQuestion: [],
		showAnswer: [],
	};

	$scope.getMatrixAbilityTitle = function getMatrixAbilityTitle(abilityId) {
		var filtered = $scope.exam.gradingMatrix.abilities.filter(function filterAbility(ability) {
			return ability.id === abilityId;
		});
		return filtered.length && filtered[0].title;
	};

	$scope.getMatrixGradeTitle = function getMatrixGradeTitle(gradeId) {
		var filtered = $scope.exam.gradingMatrix.grades.filter(function filterGrade(grade) {
			return grade.id === gradeId;
		});
		return filtered.length && filtered[0].title;
	};

	$scope.getMatrixCriteria = function getMatrixCriteria(gradeId, abilityId) {
		var criteria = $scope.exam.gradingMatrix.getCriterion({id: gradeId}, {id: abilityId});
		return criteria && criteria.description;
	};

	$scope.previewGradingMatrix = function previewGradingMatrix() {
		var popupScope = $rootScope.$new();
		popupScope.matrix = this.exam.gradingMatrix;
		dxDialog.show({
			templateUrl: "/partials/popups/view-grading-matrix.html",
			$scope: popupScope,
		});
	};

	$scope.isPartVisible = function isPartVisible(part) {
		return ($scope.exam.publishedParts & part) > 0;
	};

	$scope.isQuestionFeedbackVisible = function isQuestionFeedbackVisible(index) {
		var noteVisible = $scope.isPartVisible(DX_EXAM_PARTS.ANSWER_TEACHER_NOTE);
		var annotationsVisible = $scope.isPartVisible(DX_EXAM_PARTS.ANSWER_ANNOTATIONS);
		var hasNote = !!$scope.exam.settings.student.answers[index].grade.note;
		var hasAnnotations = $scope.exam.settings.student.answers[index].grade.getAnnotations().length > 1;
		return noteVisible && hasNote || annotationsVisible && hasAnnotations;
	};

	$scope.isAnswerVisible = function isAnswerVisible(question) {
		if (!$scope.isPartVisible(DX_EXAM_PARTS.ANSWER_DATA) && question.type === $scope.DX_QUESTION_TYPE.TEXT) {
			return false;
		}

		if (!$scope.isPartVisible(DX_EXAM_PARTS.QUESTION_ALTERNATIVE) && (question.type === $scope.DX_QUESTION_TYPE.SINGLE_CHOICE || question.type === $scope.DX_QUESTION_TYPE.MULTIPLE_CHOICE)) {
			return false;
		}

		return true;
	};

	$scope.userIsSchoolStaff = function userIsSchoolStaff() {
		var role = dxSession.getRole();
		if (role.roleType === RoleTypeEnum.ACCOUNTMANAGER || role.roleType === RoleTypeEnum.TEACHER || role.roleType === RoleTypeEnum.ADMIN) {
			return true;
		}

		return false;
	};

	// Initialize

	return dxExam.report(examId, studentId).then(function response(res) {
		$scope.exam = res;
		if ($scope.exam.settings.student.RedactedPii) {
			$scope.exam.settings.student.name = dxLocalize.get("RedactedPii.StudentName");
		}
		$scope.state.isInitialized = true;
		$scope.accessibilityFlags = {
			spellcheck: $scope.exam.settings.spellcheckAccessed,
			audioFile: $scope.exam.settings.mp3Accessed,
			textToSpeech: $scope.exam.settings.textToSpeechAccessed,
			extendedTime: $scope.exam.settings.extendedTimeAccessed,
			immersiveReader: $scope.exam.settings.immersiveReaderAccessed,
		};
	});
});
